export default "__VITE_ASSET__0743d8f5__"